<template lang="pug">
  div(class='ds-aspect-ratio ds-aspect-ratio--appearance_cuted ds-aspect-ratio--appearance_filled ds-aspect-ratio--ratio_16x9')
    iframe(
      class="ds-aspect-ratio__body"
      :src="urlCorrect"
      frameborder="0"
      style="border: 0"
      allowfullscreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
    )

</template>
<script>
import { getId } from '@utils/helpers'

export default {
  name: 'UiYoutubePlayer',
  props: {
    url: {},
  },
  data() {
    return {
      urlCorrect: `//www.youtube.com/embed/${this.getId(this.url)}?modestbranding=0&rel=0&autoplay=0&mute=0&iv_load_policy=3`,
    }
  },
  computed: {
    preview() {
      return `https://img.youtube.com/vi/${this.getId(this.url)}/0.jpg`
    },
  },
  methods: {
    getId,
  },
}

</script>
